module.exports = __webpack_public_path__ + "media/images/landing/en/create@2x-f07d87846baf47acf6196d2743aa1246.webp";